import { render, staticRenderFns } from "./Remarks.vue?vue&type=template&id=5e20cba2"
import script from "./Remarks.vue?vue&type=script&lang=js"
export * from "./Remarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports